// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-card {
  background: linear-gradient(45deg, #f1e8d6, #f6efdd);
  color: white;
}

.custom-card-desactivado {
  background: linear-gradient(45deg, #808080, #D3D3D3); /* Gris a gris claro */
  color: white;
}

.etiquetas {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}

ion-badge {
  --background: rgba(255, 255, 255, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/app/components/turno/turno.component.scss"],"names":[],"mappings":"AAAA;EACI,oDAAA;EACA,YAAA;AACJ;;AAEA;EACI,oDAAA,EAAA,sBAAA;EACA,YAAA;AACJ;;AAGA;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,sCAAA;AAAJ","sourcesContent":[".custom-card {\r\n    background: linear-gradient(45deg, #f1e8d6, #f6efdd);\r\n    color: white;\r\n}\r\n\r\n.custom-card-desactivado {\r\n    background: linear-gradient(45deg, #808080, #D3D3D3); /* Gris a gris claro */\r\n    color: white;\r\n}\r\n\r\n\r\n.etiquetas {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 15px;\r\n}\r\n\r\nion-badge {\r\n    --background: rgba(255, 255, 255, 0.2);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
